const DividerHeight = {
  regular: "h-px",
  large: "h-1",
} as const;

type DividerHeightType = keyof typeof DividerHeight;

export const Divider = ({
  orientation = "horizontal",
  hasMargin = true,
  bgColorType = "default",
  className,
  height = "regular",
}: {
  orientation?: "horizontal" | "vertical";
  hasMargin?: boolean;
  bgColorType?: "default" | "checkout-old" | "light" | "settings";
  className?: string;
  height?: DividerHeightType;
}) => {
  const bgColor = (() => {
    switch (bgColorType) {
      case "checkout-old":
        return "bg-old-checkout-border";
      case "light":
        return "bg-stg-grey-2";
      default:
        return "bg-stg-secondary-cta";
      case "settings":
        return "bg-stg-grey-1";
    }
  })();

  const heightClass = DividerHeight[height];

  return (
    <div
      className={`${
        orientation === "horizontal"
          ? `${hasMargin ? "my-4" : ""} ${heightClass} w-full`
          : `${hasMargin ? "mx-4" : ""} h-full w-px`
      } ${bgColor} ${className}`}
    />
  );
};
